import { Record } from 'immutable';

const defaultValues = {
  editableRowId: null,
  editableItem: null,
  updatingRow: false,
  partiallyUpdate: false,
  anyFieldModified: false,
  itemSource: null,
  updatingTimestamp: null,
};

export default class EditableTable extends Record(defaultValues, EditableTable) {
  constructor(values) {
    super({
      ...values,
    });
  }

  updateEditableItemRecordValue(key, value) {
    return this.setIn(['editableItem', `${ key }`], value);
  }
}
